class LanguageSelectorController {

  // TODO: CONSTANTS
  // static const SUFIX = '-label';

  constructor($translate, $state, LANGUAGES) {
    'ngInject';
    this.name = 'languageSelector';
    this.$translate = $translate;
    this.languages = LANGUAGES;
    this.$state = $state;
    let currentLanguage = $translate.proposedLanguage();
    $translate.onReady().then(this.setLanguage.bind(this, currentLanguage));


  }

  fetchLanguage(lang) {
    this.$translate.use(lang).then(this.setLanguage.bind(this, lang));
  };

  setLanguage(lang) {
    this.language = lang;
    this.languageLabel = this.language + '-label';
    this.languageLabelInstant = this.$translate.instant(this.languageLabel);
    this.$state.reload('home');
  }

  toggleDropdown($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  };

}


export default LanguageSelectorController;



// WEBPACK FOOTER //
// ./client/app/common/languageSelector/languageSelector.controller.js